import { render, staticRenderFns } from "./GithubOpenModal.vue?vue&type=template&id=c9f6b100&"
import script from "./GithubOpenModal.vue?vue&type=script&lang=js&"
export * from "./GithubOpenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubOpenModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GithubOpenModal.vue
// module id = 2361
// module chunks = 1